const UK_COUNTRIES_DICT = {
  '': '',
  england: 'England',
  scotland: 'Scotland',
  ni: 'Northern Ireland',
  wales: 'Wales',
} as const;

export default UK_COUNTRIES_DICT;
